// @flow

/* ----------------------------- VIEW OPTIONS ------------------------------
 These view types are set in the 'view' column of the dashboard_user table,
 and is used to record which dashboard view that user was last on.
 An entry would look like this for a user who was last on org '123':
    {
      current: 'org',
      app_id: null,
      organization_id: '123',
      agency_id: null
    }
 The expectaction is that only one of the id fields would be filled, all
 others than the 'current' type would be null.

 Here are the views we have available on the dashboard:
 * ------------------------------------------------------------------------- */

export const APP_VIEW = 'app';
export const APP_VIEW_ID_FIELD = 'app_id';

export const WITH_ORG = 'appValueIfHasParentOrg';
export const WITHOUT_ORG = 'appValueIfHasNoParentOrg';

export const INHERITING = 'appValueIfInheritingFromOrg';
export const NOT_INHERITING = 'appValueIfNotInheritingFromOrg';

export const ORG_VIEW = 'org';
export const ORG_VIEW_ID_FIELD = 'organization_id';

export const AGENCY_VIEW = 'agency';
export const AGENCY_ORG_TYPE = 'agency';

export const MAX_APP_DISPLAYED = 8000;

/* ------------------------- COMMON ENTITY FIELDS -----------------------------
 There are some fields that are common across the org and app tables. We want
 ensure we use the same keys for each entity:
 * ------------------------------------------------------------------------- */

export const ATTRIBUTION_SETTINGS_KEY = 'attribution_settings';
